// extracted by mini-css-extract-plugin
module.exports = {"buttons_group":"HighlightButtonsGroup_buttons_group__TUOVQ","comment_btn":"HighlightButtonsGroup_comment_btn__X8Dve","down_arrow_tip":"HighlightButtonsGroup_down_arrow_tip__2pxwp"};